// extracted by mini-css-extract-plugin
module.exports = {"shadowedBox":"MediaCard_shadowedBox__wy1Ks","titleDiv":"MediaCard_titleDiv__tAA4b","subtitle":"MediaCard_subtitle__Oyj9z"};